//import { formControlClasses } from '@mui/material/FormControl';
import { createTheme } from '@mui/material/styles';

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: '#2563EB',
      light: '#3B82F6',
      dark: '#1E40AF',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#64748B',
      light: '#94A3B8',
      dark: '#475569',
      contrastText: '#FFFFFF',
    },
    background: {
      default: mode === 'dark' ? '#0F172A' : '#F5F7FB',
      paper: mode === 'dark' ? '#1E293B' : '#FFFFFF',
    },
    text: {
      primary: mode === 'dark' ? '#F8FAFC' : '#1E293B',
      secondary: mode === 'dark' ? '#94A3B8' : '#64748B',
    },
    sidebar: {
      main: mode === 'dark' ? '#0B1120' : '#FFFFFF',
      light: mode === 'dark' ? '#1E293B' : '#F8FAFC',
      dark: mode === 'dark' ? '#030712' : '#E2E8F0',
      contrastText: mode === 'dark' ? '#FFFFFF' : '#1E293B',
    },

    success: {
      main: '#10B981',
    },
    warning: {
      main: '#F59E0B',
    },
    error: {
      main: '#EF4444',
    },
    info: {
      main: '#3B82F6',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '0.875rem',
    },
    body2: {
      fontSize: '0.8125rem',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: mode === 'dark' 
            ? '0 1px 3px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.2)'
            : '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
          borderRadius: 12,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
  shadows: [
    'none',
    mode === 'dark' 
      ? '0 1px 3px rgba(0, 0, 0, 0.3), 0 1px 2px rgba(0, 0, 0, 0.2)'
      : '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
    mode === 'dark'
      ? '0 4px 6px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2)'
      : '0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
    mode === 'dark'
      ? '0 10px 15px rgba(0, 0, 0, 0.3), 0 4px 6px rgba(0, 0, 0, 0.2)'
      : '0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)',
    mode === 'dark'
      ? '0 20px 25px rgba(0, 0, 0, 0.3), 0 10px 10px rgba(0, 0, 0, 0.2)'
      : '0 20px 25px rgba(0, 0, 0, 0.1), 0 10px 10px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 25px 50px rgba(0, 0, 0, 0.3), 0 12px 24px rgba(0, 0, 0, 0.2)'
      : '0 25px 50px rgba(0, 0, 0, 0.1), 0 12px 24px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 30px 60px rgba(0, 0, 0, 0.3), 0 15px 30px rgba(0, 0, 0, 0.2)'
      : '0 30px 60px rgba(0, 0, 0, 0.1), 0 15px 30px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 35px 70px rgba(0, 0, 0, 0.3), 0 18px 36px rgba(0, 0, 0, 0.2)'
      : '0 35px 70px rgba(0, 0, 0, 0.1), 0 18px 36px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 40px 80px rgba(0, 0, 0, 0.3), 0 20px 40px rgba(0, 0, 0, 0.2)'
      : '0 40px 80px rgba(0, 0, 0, 0.1), 0 20px 40px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 45px 90px rgba(0, 0, 0, 0.3), 0 22px 45px rgba(0, 0, 0, 0.2)'
      : '0 45px 90px rgba(0, 0, 0, 0.1), 0 22px 45px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 50px 100px rgba(0, 0, 0, 0.3), 0 25px 50px rgba(0, 0, 0, 0.2)'
      : '0 50px 100px rgba(0, 0, 0, 0.1), 0 25px 50px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 55px 110px rgba(0, 0, 0, 0.3), 0 27px 55px rgba(0, 0, 0, 0.2)'
      : '0 55px 110px rgba(0, 0, 0, 0.1), 0 27px 55px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 60px 120px rgba(0, 0, 0, 0.3), 0 30px 60px rgba(0, 0, 0, 0.2)'
      : '0 60px 120px rgba(0, 0, 0, 0.1), 0 30px 60px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 65px 130px rgba(0, 0, 0, 0.3), 0 32px 65px rgba(0, 0, 0, 0.2)'
      : '0 65px 130px rgba(0, 0, 0, 0.1), 0 32px 65px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 70px 140px rgba(0, 0, 0, 0.3), 0 35px 70px rgba(0, 0, 0, 0.2)'
      : '0 70px 140px rgba(0, 0, 0, 0.1), 0 35px 70px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 75px 150px rgba(0, 0, 0, 0.3), 0 37px 75px rgba(0, 0, 0, 0.2)'
      : '0 75px 150px rgba(0, 0, 0, 0.1), 0 37px 75px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 80px 160px rgba(0, 0, 0, 0.3), 0 40px 80px rgba(0, 0, 0, 0.2)'
      : '0 80px 160px rgba(0, 0, 0, 0.1), 0 40px 80px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 85px 170px rgba(0, 0, 0, 0.3), 0 42px 85px rgba(0, 0, 0, 0.2)'
      : '0 85px 170px rgba(0, 0, 0, 0.1), 0 42px 85px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 90px 180px rgba(0, 0, 0, 0.3), 0 45px 90px rgba(0, 0, 0, 0.2)'
      : '0 90px 180px rgba(0, 0, 0, 0.1), 0 45px 90px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 95px 190px rgba(0, 0, 0, 0.3), 0 47px 95px rgba(0, 0, 0, 0.2)'
      : '0 95px 190px rgba(0, 0, 0, 0.1), 0 47px 95px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 100px 200px rgba(0, 0, 0, 0.3), 0 50px 100px rgba(0, 0, 0, 0.2)'
      : '0 100px 200px rgba(0, 0, 0, 0.1), 0 50px 100px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 105px 210px rgba(0, 0, 0, 0.3), 0 52px 105px rgba(0, 0, 0, 0.2)'
      : '0 105px 210px rgba(0, 0, 0, 0.1), 0 52px 105px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 110px 220px rgba(0, 0, 0, 0.3), 0 55px 110px rgba(0, 0, 0, 0.2)'
      : '0 110px 220px rgba(0, 0, 0, 0.1), 0 55px 110px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 115px 230px rgba(0, 0, 0, 0.3), 0 57px 115px rgba(0, 0, 0, 0.2)'
      : '0 115px 230px rgba(0, 0, 0, 0.1), 0 57px 115px rgba(0, 0, 0, 0.04)',
    mode === 'dark'
      ? '0 120px 240px rgba(0, 0, 0, 0.3), 0 60px 120px rgba(0, 0, 0, 0.2)'
      : '0 120px 240px rgba(0, 0, 0, 0.1), 0 60px 120px rgba(0, 0, 0, 0.04)',
  ],
});

const theme = createTheme(getDesignTokens('light'));

export { getDesignTokens };
export default theme;
